var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Color } from "../../properties/color";
import { Sizing } from "../../properties/resizing";
import { Spacing } from "../../properties/spacing";
import layoutComponentsDictionary from "../layoutComponentsDictionary";
/**
 * Settings of Layout columns
 *
 * @param moduleName
 * @param layoutName
 * @param packageName
 */
export function LayoutColumnsSettings() {
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "p-4" }, { children: "Layout columns :: settings" })), _jsx(Spacing, {}), _jsx(Color, {}), _jsx(Sizing, {})] }));
}
layoutComponentsDictionary.registerLayoutComponent("layout-columns-settings", LayoutColumnsSettings);
